<template>
  <div>
    <div>
      <j-flow
        ref="flow"
        @row-click="flowRowClick"
        @pagination="hideFloatingPrompt"/>

      <jFlowFloatingPrompt
        v-if="flow"
        ref="flowFloating"
        :flow="flow"
        @hideFloatingPrompt="hideFloatingPrompt"
        @deleteFlow="deleteFlow"/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import jFlow from './jFlow';
import jFlowFloatingPrompt from './jFlowFloatingPrompt';

export default {
  // eslint-disable-next-line
  name: 'jFlowIndex',
  components: {
    jFlowFloatingPrompt,
    jFlow,
  },
  data() {
    return {
      flow: null,
    };
  },
  computed: {
    ...mapState('jStoreFlows', ['manage_rule', 'is_flow_deleted']),
    flow_id() {
      if (this.flow) {
        return this.flow.id;
      }
      return null;
    },
  },
  watch: {
    is_flow_deleted() {
      if (this.is_flow_deleted) {
        this.$refs.flow.refreshTable();
        this.$store.commit('jStoreFlows/flowDeleted');
      }
    },
    // eslint-disable-next-line
    'manage_rule.is_open': function() {
      if (this.flow !== null) {
        this.hideFloatingPrompt();
      }
    },
  },
  created() {
    // this.getListFlow();
  },
  methods: {
    ...mapActions('jStoreFlows', ['removeFlow']),

    flowRowClick(data) {
      this.flow = data.row;
      this.flow.flow_type = 1;
      if (this.rules) {
        this.$refs.rules.removeRowClick(this.rules_id);
      }
      this.rules = null;
    },

    hideFloatingPrompt() {
      if (this.flow) {
        if (this.flow_id) {
          this.$refs.flow.removeRowClick(this.flow_id);
          setTimeout(() => {
            this.flow = null;
          }, 200);
        }
        setTimeout(() => {
          this.flow = null;
        }, 200);
      } else {
        if (this.rules_id) {
          this.$refs.rules.removeRowClick(this.rules_id);
          setTimeout(() => {
            this.rules = null;
          }, 200);
        }
        setTimeout(() => {
          this.rules = null;
        }, 200);
      }
    },

    deleteFlow() {
      const deleteFlow = {
        id: this.flow_id,
      };
      this.removeFlow(deleteFlow);
      // this.$refs.flow.refreshTable();
      this.hideFloatingPrompt();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/flow-rule/flow/flow-non-sla/jFlowIndex.vue